angular.module('app.factories').factory('DataTablesFactory', ($templateCache, $interpolate, $timeout, $translate, notify, DTOptionsBuilder, DTColumnBuilder, variables) => {
    const DataTables = {
        dtInstance: {},
        dtOptions: {},
        refreshCallback: angular.noop,
        initCallback: angular.noop,
    };

    return {
        init(options) {
            if (options.refreshCallback) {
                DataTables.refreshCallback = options.refreshCallback || angular.noop;
            }

            if (options.initCallback) {
                DataTables.initCallback = options.initCallback || angular.noop;
            }

            DataTables.dtOptions = DTOptionsBuilder.newOptions()
                .withOption('stateSave', true)
                .withPaginationType('full_numbers')
                .withColumnFilter({})
                .withOption('columnDefs', options.columnDefs || {})
                .withOption('initComplete', (settings) => {
                    const dtApi = new $.fn.dataTable.Api(settings);
                    const columns = [];

                    dtApi
                        .columns()
                        .header()
                        .to$()
                        .each((i, th) => {
                            columns.push({
                                label: th.innerText,
                                checked: dtApi.column(i).visible() ? 'checked' : '',
                            });
                        });

                    // @todo: refactor
                    jQuery('.dt-uikit').on('click', '[data-column]', (e) => {
                        const el = jQuery(e.currentTarget);
                        const i = el.data('column');
                        const state = !dtApi.column(i).visible();

                        dtApi.column(i).visible(state);
                        el.find('input').prop('checked', state);

                        e.preventDefault();
                        e.stopPropagation();
                    });

                    // dodajemy listę kolumn do pokazania
                    $timeout(() => {
                        const templateItem = $templateCache.get('/directives/datatables/datatables-colvis-element.html');
                        const templateList = $templateCache.get('/directives/datatables/datatables-colvis.html');
                        const interpolatedItem = $interpolate(templateItem);
                        const interpolatedList = $interpolate(templateList);
                        const list = columns.map((column, i) => interpolatedItem({ i, column })).join('');
                        const parent = angular.element('div.dt-custom-header');

                        if (!parent.children().length) {
                            angular.element('div.dt-custom-header').append(interpolatedList({ list }));
                        }
                    }, 250);
                });

            return DataTables;
        },

        prepareStats(source, options) {
            const defaultColors = ['#2196f3', '#e53935', '#ffa000', '#7cb342', '#bdbdbd'];

            let stats = {
                fields: {},
            };

            const fieldsToPrepare = options.fields || {};
            const callback = options.callback || null;

            fieldsToPrepare.forEach((field) => {
                stats.fields[field] = {};
                stats.fields[field].data = source[field];

                stats.fields[field].values = _.map(source[field], (row) => row.c);

                stats.fields[field].labels = _.map(source[field], (row) => row.value);

                if (source[field].css_class) {
                    stats.fields[field].colors = _.map(source[field], (row) => {
                        const cssClassSuffix = (row.css_class || '').replace(/uk-badge-|uk-/, '');

                        return variables.colors[cssClassSuffix] || variables.colors.primary;
                    });
                } else {
                    stats.fields[field].colors = defaultColors;
                }
            });

            if (callback) {
                stats = callback(stats);
            }

            return stats;
        },
    };
});

angular.module('app.directives').directive('vpDtChartTable', () => ({
    restrict: 'E',

    scope: {
        model: '=model',
    },

    controller($scope) {
        $scope.$watch('model.data', () => {
            let sum = 0;

            angular.forEach($scope.model.data, (row) => {
                sum += parseFloat(row.c);
            });

            $scope.sum = sum;
        });
    },

    templateUrl: '/directives/datatables/datatables-chart-table.html',
}));

// @todo: refactor
jQuery.extend(jQuery.fn.dataTable.defaults.oLanguage, {
    sProcessing: 'Przetwarzanie...',
    sLengthMenu: 'Pokaż _MENU_ pozycji',
    sZeroRecords: 'Nie znaleziono pasujących pozycji',
    sInfoThousands: ' ',
    sInfo: 'Pozycje od _START_ do _END_ z _TOTAL_ łącznie',
    sInfoEmpty: 'Pozycji 0 z 0 dostępnych',
    sInfoFiltered: '(filtrowanie spośród _MAX_ dostępnych pozycji)',
    sInfoPostFix: '',
    sSearch: 'Szukaj:',
    sUrl: '',
    oPaginate: {
        sFirst: 'Pierwsza',
        sPrevious: 'Poprzednia',
        sNext: 'Następna',
        sLast: 'Ostatnia',
    },
    sEmptyTable: 'Brak danych',
    sLoadingRecords: 'Wczytywanie...',
    oAria: {
        sSortAscending: ': aktywuj, by posortować kolumnę rosnąco',
        sSortDescending: ': aktywuj, by posortować kolumnę malejąco',
    },
});

// error handling
jQuery.fn.dataTable.ext.errMode = (settings, helpPage, message) => {
    notify.danger($translate.instant('request_error_refresh'));
};

// sortowanie kwot
jQuery.fn.dataTable.ext.type.order['value-pln-pre'] = (d) => parseFloat(d.replace(/[^0-9]/g, ''));

// sortowanie symboli
jQuery.fn.dataTable.ext.type.order['symbol-pre'] = (html) => {
    const matches = html.match(/\"\>([^\s]+)\s&nbsp;/);
    let sum = 0;

    if (matches) {
        const parts = matches[1].split('/');
        let m = 1000000;

        for (let i = 0; i < parts[0].length; ++i) {
            sum += (255 - parts[0].charCodeAt(i)) * m;
            m /= 10;
        }
        sum += parseInt(parts[3]);
    }

    return sum;
};
